// extracted by mini-css-extract-plugin
export default {"dialogTitle":"DialogTitleWithClose_dialogTitle__07gYY","icon":"DialogTitleWithClose_icon__tBDXX"};